export function SAVE_CATEGORIES(state, [categories]){
    state.categories = categories
}

export function SAVE_CATEGORY(state, [category]){
    state.category = category
}

export function SAVE_SEARCH(state, [search]){
    state.search = search
}